import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createSlots as _createSlots, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]

import {computed, getCurrentInstance, onBeforeUnmount, ref, watch} from 'vue';
import {EventManagerInstance} from "~/cabinet/ts/Constant";
import {
    AUDIO_BUTTON_PLAY_EVENT,
    AUDIO_PLAY_BUTTON_DISABLE_PAUSE_ON_UNMOUNT, AudioButtonPlayEventInterface,
    IAudioPlayButton
} from "~/cabinet/vue/interface/data/IAudioPlayButton";
import * as moment from "~/node_modules/moment";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import Random from "~/ts/library/Random";
import Events from "~/ts/library/Events";




const __default__ = {
    name: "AudioPlayButton"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    audioElement: {},
    src: {},
    showDuration: { type: Boolean },
    showDownload: { type: Boolean },
    speed: {},
    fileName: {}
  },
  emits: ["play", "ended"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let instance = getCurrentInstance().proxy;

let uid = Random.uid();


let audio: HTMLAudioElement = props.audioElement ?? new Audio();

let isPlaying = ref(!audio.paused);
let duration = ref<number>();

addDisposableEvent(Events.addEventListener("play", audio, () => onPlay()));
addDisposableEvent(Events.addEventListener("playing", audio, () => onPlay()));
addDisposableEvent(Events.addEventListener("pause", audio, () => onPause()));
addDisposableEvent(Events.addEventListener("loadedmetadata", audio, () => detectDuration()));
addDisposableEvent(Events.addEventListener("ended", audio, () => emits("ended", audio)));


watch(computed(() => props.speed), speed => {
    audio.playbackRate = speed ? speed : 1
}, {
    immediate: true
});

if (props.showDuration) {
    if (audio.src != props.src) {
    audio.src = props.src;
    }
}

let durationDisplayed = computed(() => {
    return props.showDuration && durationDescr.value != null;
});

let durationDescr = computed(() => {
    return duration.value && duration.value != Infinity ? moment.utc(duration.value * 1000).format("mm:ss") : null;
});

function getFixedDuration(): Promise<number> {
    return new Promise(async resolve => {
        if (audio.duration > 0) {
            resolve(audio.duration);
        } else {
            let currentTime = audio.currentTime;
            let volume = audio.volume;
            let callback = () => {
                let _duration = audio.duration;
                if (_duration != Infinity && !isNaN(_duration)) {
                    duration.value = audio.duration;
                    audio.removeEventListener("durationchange", callback);
                    try {
                        audio.pause();
                    } catch (e) {

                    }
                    audio.currentTime = currentTime;
                    audio.volume = volume;
                    resolve(_duration);
                }
            };
            try {
                Events.once("durationchange", audio, callback);
                //audio.addEventListener("durationchange", callback, false);
                audio.load();
                audio.currentTime = 24 * 60 * 60; //fake big time
                audio.volume = 0;
                await audio.play();
            } catch (e) {
            }
        }
    });
}

let detectDurationStarted = ref(false);

async function detectDuration() {
    if (!detectDurationStarted.value) {
        detectDurationStarted.value = true;
        let _duration = audio.duration;
        if (_duration == Infinity || isNaN(_duration)) {
            _duration = await getFixedDuration();
        }

        duration.value = isNaN(_duration) ? null : Math.round(_duration);
        detectDurationStarted.value = false;
    }
}


onBeforeUnmount(() => {
    try {
        if (!audio.getAttribute(AUDIO_PLAY_BUTTON_DISABLE_PAUSE_ON_UNMOUNT)) {
            audio.pause();
        }
    } catch (e) {

    }
    //audio.remove();
});

let icon = computed(() => {
    return isPlaying.value && !detectDurationStarted.value ? "pause" : "play";
});

function onPlay() {
    if (!isPlaying.value) {
        emits("play", audio);
    }
    isPlaying.value = true;
    let payload: AudioButtonPlayEventInterface = {
        instance: instance,
        audio
    };
    EventManagerInstance.emit(AUDIO_BUTTON_PLAY_EVENT, payload);
}

function onPause() {
    isPlaying.value = false;
}

function pause() {
    if (isPlaying.value) {
        audio.pause();
    }
}

async function play() {
    if (!isPlaying.value) {
        if (audio.src != props.src) {
            audio.src = props.src;
        }
        audio.currentTime = 0;
        await detectDuration();
        audio.play();
    }
}

function onClick() {
    if (isPlaying.value) {
        pause();
    } else {
        play();
    }
}

addDisposableEvent(
    EventManagerInstance.addEventListener(AUDIO_BUTTON_PLAY_EVENT, (data) => {
        if (data.instance != instance) {
            pause();
        }
    })
);

__expose<IAudioPlayButton>({
    play,
    pause
});


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ icon: _unref(icon), duration: _unref(durationDescr), onClick: onClick })))
        ]))
      : (_openBlock(), _createBlock(_component_el_button_group, { key: 1 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              circle: !_unref(durationDisplayed) && !__props.showDownload,
              round: _unref(durationDisplayed) || __props.showDownload
            }, _createSlots({
              default: _withCtx(() => [
                (_unref(durationDisplayed) && _unref(durationDescr))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_unref(durationDescr)), 1)
                    ], 64))
                  : (_openBlock(), _createBlock(FontAwesomeIcon, {
                      key: 1,
                      icon: _unref(icon)
                    }, null, 8, ["icon"]))
              ]),
              _: 2
            }, [
              (_unref(durationDisplayed) && _unref(durationDescr))
                ? {
                    name: "icon",
                    fn: _withCtx(() => [
                      _createVNode(FontAwesomeIcon, { icon: _unref(icon) }, null, 8, ["icon"])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["circle", "round"])), [
              [
                _directive_on_native,
                onClick,
                "click",
                {
                  stop: true,
                  stopImmediate: true,
                  capture: true
                }
              ]
            ]),
            (__props.showDownload)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: __props.src,
                  target: "_blank",
                  class: "el-button el-button--default is-round"
                }, [
                  _createVNode(FontAwesomeIcon, { icon: "download" })
                ], 8, _hoisted_2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
  ]))
}
}

})